import React, { useEffect, useState } from "react";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import logoLight from "../../Assets/images/Omphalos-small.png";
import { toast } from "react-toastify";
import "../../STYLE/ForgotPasswordPage.css"; 
import {
  CLICK_HERE,
  EMAIL_LABEL,
  EMPTY_STRING,
  ENTER_YOUR_EMAIL_AND_INSTRUCTIONS_WILL_BE_SENT,
  FORGOT_PASSWORD_TITLE,
  SEND_OTP,
  VERIFY_EMAIL,
  WAIT_I_REMEMBER,
} from "Components/constants/commonNames";
import {REQUEST_VERIFY_EMAIL_COMMON } from "API/Services/common";
import BaseButton from "../../Components/Common/BaseButton";
import BaseInput from "../../Components/Common/BaseInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  EMAIL_REGEX,
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import { checkStatusCodeSuccess, SESSION_SET_ITEM } from "Components/constants/enums";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(EMAIL_REGEX, validationMessages.format(EMAIL_LABEL))
    .required(validationMessages.required(EMAIL_LABEL)),
});

const ForgotPassword = (props: any) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);

  const initialValues = {
    email: "",
  };

  const handleSubmit = async (values: typeof initialValues) => {
    setLoader(true);
    const payload = { email: values.email };

    try {
      const resp: any = await REQUEST_VERIFY_EMAIL_COMMON(payload);
      if (checkStatusCodeSuccess(resp?.statusCode)) {
        toast.success(resp?.message);
        SESSION_SET_ITEM("email",payload.email)
        navigate("/update-password");
      } else {
        toast.error(resp?.message);
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message);
    } finally {
      setLoader(false);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

    document.title = FORGOT_PASSWORD_TITLE;

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container className="mt-5">
            <Row>
              <Col lg={12}>
                <div className="text-center mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" className="logocss" />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-2 login-card">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <span className="text-info hello">{VERIFY_EMAIL}</span>
                    </div>
                    <Alert color="warning" className="text-center mx-2 alert-margin">
                      {ENTER_YOUR_EMAIL_AND_INSTRUCTIONS_WILL_BE_SENT}
                    </Alert>
                    <div className="p-2">
                      <form onSubmit={formik.handleSubmit}>
                        <BaseInput
                          label={EMAIL_LABEL}
                          className="mb-3"
                          name="email"
                          type="email"
                          placeholder={InputPlaceHolder(EMAIL_LABEL)}
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.errors.email}
                          touched={formik.touched.email}
                        />
                        <div className="mt-1">
                          <BaseButton
                            text={loader ? EMPTY_STRING : SEND_OTP}
                            loading={loader}
                            type="submit"
                            color="info"
                          />
                        </div>
                        
                      </form>
                    </div>
                  </CardBody>
                </Card>
                
              </Col>
              <div className="text-center">
                {WAIT_I_REMEMBER}
                          <Link to="/login" className="text-info">
                            {CLICK_HERE}
                          </Link>
                        </div>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(ForgotPassword);
